export default __webpack_public_path__ + "static/media/pnp.0a2d3507.jpg";